<template>
  <a-card :bordered="false">
    <CustomCrumbs :data-list="crumbsList" show-name="title"></CustomCrumbs>
    <div style="height: 20px"></div>
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['s1','s2','s3','s4','s5']"
      :columns="getDeviceColumns()"
      :queryParams="queryParams"
      row-key="deviceId"
      :leftSpace="10"
      :requestPromise="getDeviceList"
    >
      <a-form-item slot="s1" label="设备ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="货仓号" v-bind="searchItemLayout">
        <a-select
          v-model="queryParams.seat"
          allowClear
          style="width: 100%;"
          placeholder="请选择">
          <a-select-option value="1">1</a-select-option>
          <a-select-option value="2">2</a-select-option>
          <a-select-option value="3">3</a-select-option>
          <a-select-option value="4">4</a-select-option>
          <a-select-option value="5">5</a-select-option>
          <a-select-option value="6">6</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="s3" label="库存状态" v-bind="searchItemLayout">
        <a-select
          v-model="queryParams.stockStatus"
          style="width: 100%;"
          allowClear
          placeholder="请选择">
          <a-select-option value="1">有</a-select-option>
          <a-select-option value="0">无</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="s4" label="渠道名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.channelName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s5" label="渠道手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.channelPhone" placeholder="请输入"></a-input>
      </a-form-item>
      <div slot="operation" style="height: 40px;line-height: 40px;margin-bottom: 20px">
        <a-button slot="add" type="primary" style="margin-left: 20px">
          <a-dropdown>
            <a class="ant-dropdown-link">+ 新建
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay" @click="addEvent">
              <a-menu-item :key="1">
                <a href="javascript:">单个添加</a>
              </a-menu-item>
              <a-menu-item :key="2">
                <a href="javascript:">批量添加</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-button>
        <span style="float: right">设置售货机商品
          <a style="margin-left: 20px" @click="toProductEvent">商品管理</a></span>
      </div>
      <div slot="seatStockList" slot-scope="rowItem" class="border-box">
        <div v-for="(item,index) in rowItem.text"
             :class="[getItemClass(rowItem.record,item),index>0?'custom-dividing-line':'']">{{ item.seat }}
        </div>
      </div>
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditEvent(rowItem.record)">编辑</a>
      </span>
    </search-page-view>
    <DeviceEditorDialog
      v-if="showSingleDialog"
      :title="editItem?'编辑设备':'添加设备'"
      :loading="submitLoading"
      :defaultForm="deviceForm"
      :show="showSingleDialog"
      @ok="editorDeviceResult"
      @cancel="showSingleDialog=false"></DeviceEditorDialog>
    <ImportFileDialog
      v-if="showImportDialog"
      :show="showImportDialog"
      @ok="importSuccess"
      @cancel="showImportDialog=false"
      :data="uploadData"
      :templateUrl="templateFileUrl"
      :url="importFileUrl"></ImportFileDialog>

  </a-card>
</template>

<script>
import smartMixins from '../smartMixins'
import CustomCrumbs from '../../../../../customComponents/CustomCrumbs'
import DeviceEditorDialog from '../components/DeviceEditorDialog'
import ImportFileDialog from '../components/ImportFileDialog'
import store from '@/store'

export default {
  name: 'VmDeviceList',
  mixins: [smartMixins],
  components: { CustomCrumbs, DeviceEditorDialog, ImportFileDialog },
  data() {
    return {
      showSingleDialog: false,
      showImportDialog: false,
      submitLoading: false,
      crumbsList: [
        {
          title: '无人售货机(客房版)'
        },
        {
          title: '设备列表'
        }
      ],
      editItem: undefined,//要编辑项
      deviceForm: {
        channelId: undefined,
        deviceId: undefined,
        deviceStatus: undefined,
        secret: undefined,
        remarks: undefined
      },//默认设备信息
      importFileUrl: '',
      uploadData: {},
      templateFileUrl: 'https://imgb.woyoubooking.com/config/iotDeviceTemplate.xlsx'
    }
  },
  created() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    this.importFileUrl = store.getters.appConfig.serviceUrl + '/iot/vem/batchSaveVemDevice'
    const data = {
      platformId: this.platformId,
      merchantId: this.merchantId
    }
    this.uploadData = { ...data }
    this.queryParams = { ...data }
  },
  mounted() {
  },

  activated() {
    this.$refs.pageList.refresh(true)
  },
  methods: {
    getItemClass(record, item) {
      if (record.channelInfo == null) {
        return 'style-3'
      } else {
        return item.stock == 1 ? 'style_1' : 'style_2'
      }
    },
    getDeviceList(params) {
      return this.getHttpServices().getServerApiService().post('/iot/vem/searchVemDeviceList', params)
    },
    addEvent(e) {
      if (e.key === 1) {
        this.editItem = undefined
        this.deviceForm = {}
        this.showSingleDialog = true
      } else {
        this.showImportDialog = true
      }
    },
    toEditEvent(record) {
      this.getHttpServices().getServerApiService().get('/iot/vem/findVemDevice', { deviceId: record.deviceId })
        .then(details => {
          this.getLogUtils().logWithTag('======findVemDevice====', details)
          this.deviceForm = {
            channelId: details.channelId,
            deviceKey: details.deviceKey,
            deviceStatus: record.deviceStatus,
            deviceNo: details.deviceNo,
            remark: details.remark
          }
          this.editItem = details
          this.showSingleDialog = true
        }).catch(reason => {
        this.getLogUtils().errorWithTag('======findVemDevice====', reason)
        this.showNetWorkErrorMessage(reason)
      })
    },
    toProductEvent() {
      let pageParams = this.getPageParams()
      this.openNewPage('VmProductManager', { ...pageParams })
    },
    editorDeviceResult(formParams) {
      this.submitLoading = true
      const deviceId = this.editItem ? this.editItem.deviceId : undefined
      let params = {
        baseDto: {
          merchantId: this.merchantId,
          platformId: this.platformId
        },
        channelId: formParams.channelId,
        deviceId: deviceId,
        deviceKey: formParams.deviceKey,
        deviceNo: formParams.deviceNo,
        remark: formParams.remark,
        status: formParams.deviceStatus
      }
      this.getLogUtils().logWithTag('======params=======', params)
      this.getHttpServices().getServerApiService().post('/iot/vem/editVemDevice', params)
        .then(res => {
          this.$message.success(deviceId ? '编辑成功' : '新增成功')
          this.showSingleDialog = false
          this.$refs.pageList.refresh(deviceId)
          this.getLogUtils().logWithTag('editVemDevice', res)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('editVemDevice', reason)
        this.showNetWorkErrorMessage(reason)
      }).finally(() => this.submitLoading = false)
    },
    getDeviceColumns() {
      return [
        {
          title: '设备编号',
          dataIndex: 'deviceNo'
        },
        {
          title: '设备ID',
          dataIndex: 'deviceId'
        },
        {
          title: '设备密钥',
          dataIndex: 'deviceKey'
        },
        {
          title: '当前渠道',
          dataIndex: 'channelInfo'
        },
        {
          title: '库存',
          dataIndex: 'seatStockList',
          scopedSlots: { customRender: 'seatStockList' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          width: '100px',
          dataIndex: 'deviceStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    importSuccess() {
      this.showImportDialog = false
      this.$nextTick(() => this.$refs.pageList.refresh(true))
    }
  }
}
</script>
<style scoped lang="less">
.border-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 42px;
  line-height: 40px;
  border: 1px solid #797979;
}

.custom-dividing-line {
  border-left: 1px solid #797979;
}

.text {
  flex-grow: 1;
  width: 40px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  color: white;
}

.style_1 {
  .text;
  background-color: #14F207;
}

.style_2 {
  .text;
  background-color: #F5222D;
}

.style-3 {
  .text;
  background-color: #CCD0CB;
}
</style>